import i18n from "../../src/i18n"

export class ApiError extends Error {
	public readonly Status: number
	public readonly I18n?: unknown
	public readonly error: unknown
	public readonly code?: string

	constructor(error: unknown, status = 500) {
		// Initialize with default message
		super("Unknown error")

		this.Status = status
		this.error = error

		// Extract i18n if available
		if (typeof error == "object" && error && "i18n" in error && typeof error.i18n == "object" && error.i18n) {
			this.I18n = error.i18n
		}

		// Set the message based on error type
		if (!error) {
			this.message = "Unknown error"
		} else if (typeof error == "string") {
			this.message = error
		} else if (typeof error == "object" && "message" in error && typeof error.message == "string") {
			this.message = error.message
		} else if (typeof error == "object" && "Message" in error && typeof error.Message == "string") {
			this.message = error.Message
		} else if (typeof error == "object" && "Errors" in error && typeof error.Errors == "object" && error.Errors) {
			const errors = error.Errors
			this.message = Object.entries(errors)
				.map(([key, value]) => `${key} ${value}`)
				.join(".")
		}

		if (!!error && typeof error == "object" && "Code" in error && typeof error.Code == "string") {
			this.code = error.Code
		}

		// Set the name for better stack traces
		this.name = "ApiError"
	}

	// For backwards compatibility, include Message property
	get Message() {
		if (this.code) {
			return i18n.t(`errors.${this.code}`, {defaultValue: this.message})
		}
		return this.message
	}

	get Code() {
		return this.code
	}
}
